export const isFloatingFleet = (aircraftData) => {
    return aircraftData?.tailNumber?.indexOf('XX-XXX') > -1 || aircraftData?.cAircraftTailNumber?.indexOf('XX-XXX') > -1
}